import PubSub from './PubSub'

PubSub.subscribe('/api/donations/new', ({ donationTotal }) => {
  console.log(donationTotal)
})

PubSub.subscribe('/api/donation-goals/reached', ({ amount, name }) => {
  console.log(amount, name);
})

PubSub.subscribe('/api/goal-wheel-actions/result', ({ obj }) => {
  console.log(obj.name)
})



// WEBPACK FOOTER //
// ./src/events.js